export default __webpack_public_path__ + "static/media/Standardization_Documentation.ddd369fd.pdf";